import { Feature } from "geojson";
import { AnySupportedGeometry } from "./map-object-geometry";
import { MapCommentProperties, MapObjectProperties } from "./map-object-properties";
import { RouteWaypoint } from "./route-waypoints";

export interface LocalGeoJsonObject {
    objectId: string;
    feature: Feature<AnySupportedGeometry, MapObjectProperties | MapCommentProperties>;
    waypoints: RouteWaypoint[];
}

export interface LocalGeoJson {
    [layerId: string]: LocalGeoJsonObject[];
}

export interface SelectedMapObject {
    layerId: string;
    objectId: string;
}
